'use client';

import { useEffect } from 'react';
import { announceSessionEnded } from '../session-broadcast';

/**
 * Rendered by the login page, which only ever shows once this browser's session is over (the proxy
 * sends a signed-in user away from it): tells every other tab to close its hub connection, so none
 * keeps the ended session's lock lease alive.
 */
export function SessionEndedAnnouncer(): null {
  useEffect(() => {
    announceSessionEnded();
  }, []);

  return null;
}
